<template>
  <main>
    <!-- Header -->
    <header class="view-catalog-list__header">
      <!-- Restaurant Information -->
      <div class="view-catalog-list__infos">
        <div class="container">
          <h1 class="view-catalog-list__title">{{ shop.name }}</h1>
          <ul class="view-catalog-list__meta">
            <li class="view-catalog-list__metaitem">{{ shop.city }}</li>
            <li class="view-catalog-list__metaitem">
              {{ $t('sayl-oat.table_number', {tableNumber: tableNumber}) }}
              <button 
                v-if="false"
                class="view-catalog-list__table"
                @click="showTablePopin = true">{{ $t('sayl-oat.table_number', {tableNumber: tableNumber}) }}</button>
            </li>
          </ul>
        </div>
      </div>

      <!-- Hero -->
      <ui-hero :figures="pictures" />
    </header>

    <!-- Body -->
    <section class="view-catalog-list__body">
      <div class="container">
        <!-- Intro -->
        <div class="view-catalog-list__intro">
          <template v-if="hasCart">
            <h1 class="view-catalog-list__intro-title">{{ $t('sayl-oat.catalog_cart_title') }}</h1>
            <p class="view-catalog-list__intro-description">{{ $t('sayl-oat.catalog_cart_description') }}</p>
          </template>

          <template v-else>
            <h1 class="view-catalog-list__intro-title">{{ $t('sayl-oat.catalog_menu_title') }}</h1>
            <p class="view-catalog-list__intro-description">{{ $t('sayl-oat.catalog_menu_description') }}</p>
          </template>
        </div>

        <!-- Content -->
        <div class="view-catalog-list__content">
          <!-- Cart -->
          <catalog-cart v-if="hasCart" />

          <!-- Categories -->
          <div class="view-catalog-list__categories">

            <!-- Categories::Navigation -->
            <CatalogCategoriesNavigation 
              v-if="false" 
              :categories="catalog.categories"/>

            <!-- Categories::Products -->
            <catalog-categories />
          </div>
        </div>
      </div>
    </section>

    <!-- Children -->
    <router-view></router-view>

    <!-- Table popin -->
    <catalog-table 
      :visible="showTablePopin"
      @close="showTablePopin = false" />

    <!-- Toolbar -->
    <catalog-toolbar />
  </main>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import PriceMixin from '@/modules/catalog/mixins/price'

import CatalogCart from '@/modules/catalog/components/catalog/cart'
import CatalogCategories from '@/modules/catalog/components/catalog/categories'
import CatalogCategoriesNavigation from '@/modules/catalog/components/catalog/navigation'
import CatalogTable from '@/modules/catalog/components/catalog/table'
import CatalogToolbar from '@/modules/catalog/components/catalog/toolbar'
import UiHero from '@/modules/catalog/components/ui/hero'

import { CartItem } from '@sayl/oat-core'

export default {
  name: 'CatalogView',

  components: {
    CatalogCart,
    CatalogCategories,
    CatalogCategoriesNavigation,
    CatalogTable,
    CatalogToolbar,
    UiHero
  },

  mixins: [
    PriceMixin
  ],

  data(){
    return {
      showTablePopin: false
    }
  },

  computed:{
    ...mapState({
      catalog: state => state['sayl-oat'].catalog,
      shop: state => state['sayl-oat'].shop,
      cart: state => state['sayl-oat'].cart,
      products: state => state.bootstrap.catalog.products,
      user: state => state['sayl-oat.user'].user,
      i18n: state => state.bootstrap.i18n,
      tables: state => state['sayl-oat'].tables
    }),

    hasCart(){
      return this.cart.items.length
    },   
    
    hasTable() {
      return !['', null, undefined].includes(this.tableNumber);
    },

    pictures(){
      return this.shop.banners || [];
    },

    tableNumber(){
      let ret = '';
      const t = this.tables.find(t => t.id === this.cart.tableNumber);

      if(t) {
        ret = t.name || ''
      }

      return ret;
    },
  },

  methods:{
    ...mapActions({
      checkout: 'checkout',
    }),

    ...mapMutations({
      setTableNumber: 'setTableNumber'
    }),

    formatProductPrice(price){
      let ret = this.toCurrency({value: price.value});

      if (price.min && price.max){
        ret = this.toRangeCurrency({min: price.min, max: price.max})
      }

      return ret;
    },
  },

  created() { 
    if (this.$route.query && this.$route.query.table) {
      let table = this.tables.find(t => t.id === this.$route.query.table);

      if(table !== undefined) {
        localStorage.setItem('table', table.id);
        this.setTableNumber(table.id);
      }
    } else if(!['', null, undefined].includes(localStorage.getItem('table'))) {
      let table = localStorage.getItem('table');
      this.setTableNumber(table);
    }

    if(this.$route.query && this.$route.query.l) {
      const lang = this.i18n.locales.find(l => {
        return this.$route.query.l.toLowerCase() === l.toISO639();
      });
      lang !== undefined && this.i18n.setLocale(lang.toISO3166());
    } else if(this.user.lang !== this.i18n.locale.toISO639()) {
      const lang = this.i18n.locales.find(l => {
        return this.user.lang === l.toISO639();
      });

      lang !== undefined && this.i18n.setLocale(lang.toISO3166());
    } else {
      const lang = this.i18n.locales.find(l => {
        return 'en' === l.toISO639();
      });
      lang !== undefined && this.i18n.setLocale(lang.toISO3166());
    }
  },
}
</script>
